import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export function TextInput({
  label,
  error,
  className = '',
  ...props
}: TextInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  return <div className="w-full space-y-4">
      <label className="block text-base font-medium text-[#2D2A35] ml-1 tracking-wide opacity-80">
        {label}
      </label>
      <div className="relative">
        <input onFocus={e => {
        setIsFocused(true);
        props.onFocus?.(e);
      }} onBlur={e => {
        setIsFocused(false);
        props.onBlur?.(e);
      }} className={`
            w-full px-6 py-5 rounded-2xl border bg-white text-[#2D2A35] placeholder-[#9B95A3]/50 text-lg
            focus:outline-none focus:border-[#9B87C7] focus:ring-0
            transition-all duration-500 shadow-sm
            ${error ? 'border-[#D97B9E]' : 'border-[#E8E4EE] hover:border-[#B5A8D4]'}
            ${className}
          `} {...props} />
      </div>

      {error && <motion.p initial={{
      opacity: 0,
      y: -5
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-sm text-[#D97B9E] ml-2 font-medium">
          {error}
        </motion.p>}
    </div>;
}